module.exports = __webpack_public_path__ + "static/media/cold.590a1eeb.jpg";